/**
 * Created by StoneWang on 2020/11/27.
 */
import React from 'react';
import {hashHistory, withRouter} from 'react-router';
import {
    Row,
    Col,
    Tabs,
    Form,
    Icon,
    Table,
    Input,
    Select,
    Modal,
    Button,
    Upload,
    TreeSelect,
    Cascader,
    message, Switch
} from 'antd';
import {
    DmsTab,
    MyUpload,
    RichEditor,
} from 'Components';
import ProductModal from './productModal';
import {
    openNotice,
    showSpin,
    hideSpin,
    unique,
    config,
    APIS
} from 'Utils';
// import {openNotice, APIS, objectSerial, config, toImportExcel} from 'Utils';

import {
    commodityDetail,
    modifyCommodity,
    addCommodity,
    productListForCommodity,
    addProductForCommodity,
    delProductForCommodity,
    setDefaultProductForCommodity,
} from '../../service/merchandise';
import {
    getProductCategory,
    uploadMeasurementReport
} from '../../service/product';
import {
    sKeylist,
} from '../../service/dictionary/dataitem';
import {Actions} from './store';

const TabPane = Tabs.TabPane;
const FormItem = Form.Item;
const Option = Select.Option;
const Search = Input.Search;
const confirm = Modal.confirm;
const {TextArea} = Input;

class MerchandiseAdd extends React.Component {
    constructor(props) {
        super(props);
        this.id = props.params.id === '0' ? 0 : props.params.id;
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            visible: false,
            submiting: false,
            groupOptions: [], // 商品分组
            seriesOptions: [], // 商品系列
            fittingTree: [],
            productCategoryTree: [],
            detail: {},
            defaultActiveKey: 1,
            loadingSpec: false,
            visibleSpec: false,
            productTotal: 0,
            productRelationList: [],
            visibleModel: false,
            zxDisplayPrice: 0,
            hideOldfiles: 0,
            lookFileUrl: '',
            selectedRowKeys: [],
            productParams: {
                name: '',
                channelCode: this.channelData.split('|')[1] || '',
                commodityId: this.id, //商品id
                s: 10,
                p: 1,
            },
            examiningReportData: {
                name: 'file',
                showUploadList: false,
                action: APIS.upload,
                headers: {
                    authorization: 'authorization-text',
                },
                onChange: this.examiningReportData.bind(this),
            },
            certificateData: {
                name: 'file',
                showUploadList: false,
                action: APIS.upload,
                headers: {
                    authorization: 'authorization-text',
                },
                onChange: this.certificateData.bind(this),
            },
            commodityData: {
                name: 'file',
                showUploadList: false,
                action: APIS.upload,
                headers: {
                    authorization: 'authorization-text',
                },
                onChange: this.commodityData.bind(this),
            },
            videoData: {
                name: 'file',
                showUploadList: false,
                action: APIS.upload,
                headers: {
                    authorization: 'authorization-text',
                },
                onChange: this.videoData.bind(this),
                beforeUpload: (file) => {
                    const isMp4 = file.type === 'video/mp4';
                    const isLt5M = file.size / 1024 / 1024 < 30; // 文件大小小于5MB
                    if (!isMp4) {
                        message.error('您只能上传 MP4 格式的文件!');
                    }
                    if (!isLt5M) {
                        message.error('文件必须小于30MB!');
                    }
                    return (isMp4 && isLt5M);
                }
            },
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}'),
            deleteRowKeys: [], // 选择的产品 id
            button_limits_end: JSON.parse(window.localStorage.getItem('button_limits_end') || '{}'),
        };
        this.submitHandle = this.submitHandle.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.goSelectProduct = this.goSelectProduct.bind(this);
        // this.exportChange = this.exportChange.bind(this);

        this.onOkHandle = this.onOkHandle.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.onSearchHandle = this.onSearchHandle.bind(this);
        this.getProductListForCommodity = this.getProductListForCommodity.bind(this);
        this.zxDisplayPriceOnChange = this.zxDisplayPriceOnChange.bind(this);
        this.hideOldfilesOnChange = this.hideOldfilesOnChange.bind(this);
    }

    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname;
        if (/^\/product\/\d+$/.test(path)) { //当下一个路由是详情页时，将useStore的值设为true
            const formData = this.props.form.getFieldsValue();
            window.sessionStorage.setItem('mechandise-form-data-cache', JSON.stringify(formData))
        }
    }

    /*上传附件  产品附件*/
    commodityData(result) {
        let {detail} = this.state;
        let data = detail.commodityList || [];
        var self = this
        if (result.file.status === 'done') {
            let responseData = result.file.response || {};
            if (responseData.code != 200) {
                openNotice('error', '附件上传失败');
                return;
            }
            var commodityList = detail.commodityList ? detail.commodityList : []
            commodityList.push({
                id: responseData.data.id,
                fileName: responseData.data.fileName,
                extension: responseData.data.extension,
                file_path: responseData.data.filePath,
            })

            var temp = {
                ...detail,
                'commodityList': commodityList,
                'commodityIds': detail.commodityIds ? detail.commodityIds + ',' + responseData.data.id : responseData.data.id
            }
            console.log(temp)
            self.setState({
                detail: temp
            })
        }
    };

    videoData(result) {
        let {detail} = this.state;
        let data = detail.videoList || [];
        var self = this
        if (result.file.status === 'done') {
            let responseData = result.file.response || {};
            if (responseData.code != 200) {
                openNotice('error', '附件上传失败');
                return;
            }
            var videoList = detail.videoList ? detail.videoList : []
            videoList.push({
                id: responseData.data.id,
                fileName: responseData.data.fileName,
                extension: responseData.data.extension,
                file_path: responseData.data.filePath,
            })

            var temp = {
                ...detail,
                'videoList': videoList,
                'videoIds': detail.videoIds ? detail.videoIds + ',' + responseData.data.id : responseData.data.id
            }
            console.log(temp)
            self.setState({
                detail: temp
            })
        }
    };

    /*上传附件  体测报告*/
    examiningReportData(result) {
        let {detail} = this.state;
        let data = detail.examiningReportList || [];
        var self = this
        if (result.file.status === 'done') {
            let responseData = result.file.response || {};
            if (responseData.code != 200) {
                openNotice('error', '附件上传失败');
                return;
            }
            var examiningReportList = detail.examiningReportList ? detail.examiningReportList : []
            examiningReportList.push({
                id: responseData.data.id,
                fileName: responseData.data.fileName,
                extension: responseData.data.extension,
                file_path: responseData.data.filePath,
            })
            var temp = {
                ...detail,
                'examiningReportList': examiningReportList,
                'examiningReportIds': detail.examiningReportIds ? detail.examiningReportIds + ',' + responseData.data.id : responseData.data.id
            }
            console.log(temp)
            self.setState({
                detail: temp
            })
        }
    };

    /*上传附件  认证证书*/
    certificateData(result) {
        let {detail} = this.state;
        let data = detail.certificateList || [];
        var self = this
        if (result.file.status === 'done') {
            let responseData = result.file.response || {};
            if (responseData.code != 200) {
                openNotice('error', '附件上传失败');
                return;
            }
            var certificateList = detail.certificateList ? detail.certificateList : []
            certificateList.push({
                id: responseData.data.id,
                fileName: responseData.data.fileName,
                extension: responseData.data.extension,
                file_path: responseData.data.filePath,
            })
            var temp = {
                ...detail,
                'certificateList': certificateList,
                'certificateIds': detail.certificateIds ? detail.certificateIds + ',' + responseData.data.id : responseData.data.id
            }
            console.log(temp)
            self.setState({
                detail: temp
            })
        }
    };

    // 文件删除
    delCommodity(res) {
        var self = this

        var data = []
        var commodityList = this.state.detail.commodityList
        commodityList.splice(commodityList.findIndex(item => item.id === res.id), 1)

        var commodityIds = this.state.detail.commodityIds.split(",")
        commodityIds.splice(commodityIds.findIndex(item => item == res.id), 1)
        this.setState({
            detail: {
                ...self.state.detail,
                'commodityList': commodityList,
                'commodityIds': commodityIds.join(',')
            }
        })
    };

    delVideo(res) {
        var self = this

        var data = []
        var videoList = this.state.detail.videoList
        videoList.splice(videoList.findIndex(item => item.id === res.id), 1)

        var videoIds = this.state.detail.videoIds.split(",")
        videoIds.splice(videoIds.findIndex(item => item == res.id), 1)
        this.setState({
            detail: {
                ...self.state.detail,
                'videoList': videoList,
                'videoIds': videoIds.join(',')
            }
        })
    };

    // 文件删除
    delFileReport(res) {
        var self = this

        var data = []
        var examiningReportList = this.state.detail.examiningReportList
        examiningReportList.splice(examiningReportList.findIndex(item => item.id === res.id), 1)

        var examiningReportIds = this.state.detail.examiningReportIds.split(",")
        examiningReportIds.splice(examiningReportIds.findIndex(item => item == res.id), 1)
        this.setState({
            detail: {
                ...self.state.detail,
                'examiningReportList': examiningReportList,
                'examiningReportIds': examiningReportIds.join(',')
            }
        })
    };

    // 文件删除
    delFileCertificateList(res) {
        var self = this

        var data = []
        var certificateList = this.state.detail.certificateList
        certificateList.splice(certificateList.findIndex(item => item.id === res.id), 1)

        var certificateIds = this.state.detail.certificateIds.split(",")
        certificateIds.splice(certificateIds.findIndex(item => item == res.id), 1)
        this.setState({
            detail: {
                ...self.state.detail,
                'certificateList': certificateList,
                'certificateIds': certificateIds.join(',')
            }
        })
    };

    handleCancel = () => {
        this.setState({visibleModel: false});
    };

    componentDidMount() {

        let self = this;
        sKeylist({sKey: 'commodity_group'}).then(res => {
            if (res.status) {
                this.setState({
                    groupOptions: (res.data || []).map(x => ({value: x.sKey, text: x.name})),
                });
            }
        });
        sKeylist({sKey: 'commodity_series'}).then(res => {
            if (res.status) {
                this.setState({
                    seriesOptions: (res.data || []).map(x => ({value: x.sKey, text: x.name})),
                });
            }
        });
        getProductCategory().then(res => {
            if (res.status) {
                const filterEmpty = (list, codePath) => list.map(x => {
                    let key = x.code; // 实际使用的业务数据是 code；
                    if (x.children && x.children.length) {
                        return {
                            ...x,
                            key: key, // 使用实际业务数据重新给 key 赋值
                            value: key, // 使用实际业务数据重新给 value 赋值
                            isLeaf: false,
                            disableCheckbox: !x.categoryId,
                            codePath: [...codePath, {code: x.code, label: x.label, categoryId: x.categoryId}],
                            children: filterEmpty(x.children, [...codePath, {
                                code: x.code,
                                label: x.label,
                                categoryId: x.categoryId
                            }]),
                        };
                    }
                    return {
                        ...x,
                        key: key, // 使用实际业务数据重新给 key 赋值
                        value: key, // 使用实际业务数据重新给 value 赋值
                        isLeaf: true,
                        disableCheckbox: !x.categoryId,
                        codePath: [...codePath, {code: x.code, label: x.label, categoryId: x.categoryId}],
                        children: undefined,
                    };
                });
                const processFittingTree = (list) => list.map(x => {
                    let key = x.key;
                    if (!!x.categoryId) {  // 配件优先保存 categoryId
                        key = `${x.categoryId}`
                    }
                    if (x.children && x.children.length) {
                        return {
                            ...x,
                            key: key, // 使用实际业务数据重新给 key 赋值
                            value: key, // 使用实际业务数据重新给 value 赋值
                            children: processFittingTree(x.children),
                        };
                    }
                    return {
                        ...x,
                        key: key, // 使用实际业务数据重新给 key 赋值
                        value: key, // 使用实际业务数据重新给 value 赋值
                    };
                });
                const tree = filterEmpty(res.data || [], []);
                const productCategoryTree = tree.filter(x => !/配件/ig.test(x.label));
                let fittingTree = tree.filter(x => /配件/ig.test(x.label));
                fittingTree = processFittingTree(fittingTree);
                console.log('debug 配件 fittingTree: ', fittingTree);
                this.setState({
                    fittingTree,
                    productCategoryTree,
                });
            }
        });
        const formCache = JSON.parse(window.sessionStorage.getItem('mechandise-form-data-cache') || '{}')
        if (this.id) {
            /*获取详情数据*/
            commodityDetail({id: this.id}).then(function (result) {
                if (result && result.code == 200) {
                    let detail = result.data || {};
                    detail.proCategoryIdShow = [detail.proBigType, detail.proMiddleType, detail.proDetailType].filter(x => !!x);
                    detail.proCategoryId = `${detail.proCategoryId || ''}`;
                    detail.partCategoryIds = detail.partCategoryIds ? detail.partCategoryIds.split(',').filter(x => !!x) : [];
                    detail.partsTypeJson = detail.partsTypeJson ? detail.partsTypeJson.replace(/\\\\"/g, '"') : '[]';
                    detail.picPreviewIds = (detail.picPreviewList || []).map((x, index) => ({
                        id: x.id,
                        uid: 0 - index - 1,
                        name: 'xxx.png',
                        status: 'done',
                        url: `${config.server}${x.file_path}`,
                        thumbUrl: `${config.server}${x.file_path}`,
                    })); // 商品缩略图
                    detail.picMainIds = (detail.picMainList || []).map((x, index) => ({
                        id: x.id,
                        uid: 0 - index - 1,
                        name: 'xxx.png',
                        status: 'done',
                        url: `${config.server}${x.file_path}`,
                        thumbUrl: `${config.server}${x.file_path}`,
                    })); // 商品主图
                    self.setState({
                        detail: detail,
                        zxDisplayPrice: detail.zxDisplayPrice,
                        hideOldfiles: detail.hideOldfiles || 0,
                        // detailExaminingReportList: detail.examiningReportList
                    }, () => {
                        if (Object.keys(formCache).length) {
                            self.props.form.setFieldsValue(formCache)
                        }
                    });
                } else {
                    openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
                }
            });
            this.getProductListForCommodity();
        } else if (Object.keys(formCache).length) {
            self.props.form.setFieldsValue(formCache)
        }

        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    getProductListForCommodity() {
        productListForCommodity(this.state.productParams).then(res => {
            if (res.status) {
                this.setState({
                    productTotal: res.total,
                    productRelationList: res.data || [],
                    productValidateStatus: !!res.total ? '' : 'error',
                });
            }
        });
    }

    goView(url) {
        hashHistory.push(url);
    }

    cancelHandle() {
        hashHistory.goBack();
    }

    // 保存操作
    submitHandle(e) {
        e.preventDefault();
        e.stopPropagation();
        const {productRelationList, informationLi, informationLi2, lookFileUrl, detail} = this.state;
        debugger;
        const {validateFields} = this.props.form;

        console.log('vadetailes', detail)
        // console.log('informationLi2', informationLi2)
        // console.log('informationLi', informationLi)

        // if (!productRelationList.length) {
        //   message.error('请选择管理产品');
        //   return;
        // }
        validateFields((err, values) => {
            console.log('err', err)
            console.log('values', values)
            if (!err) {
                const params = {

                    'examiningReportIds': detail.examiningReportIds,
                    'examiningReportList': detail.examiningReportList,
                    'certificateIds': detail.certificateIds,
                    'certificateList': detail.certificateList,
                    'commodityIds': detail.commodityIds,
                    'commodityList': detail.commodityList,
                    'videoIds': detail.videoIds,
                    //'videoList': detail.videoList,

                    ...values,
                    proBigType: values.proCategoryIdShow[0] || '', // 商品大类
                    proMiddleType: values.proCategoryIdShow[1] || '', // 商品中类
                    proDetailType: values.proCategoryIdShow[2] || '', // 商品小类
                    partCategoryIds: values.partCategoryIds ? values.partCategoryIds.join() : '', //配件小类中的分类id（多个配件category_id用英文逗号隔开）
                    partsTypeJson: values.partsTypeJson ? values.partsTypeJson.replace(/"/g, '\\\\"') : '[]',
                    picPreviewIds: values.picPreviewIds.map(x => x.id).join(),
                    picMainIds: values.picMainIds.map(x => x.id).join(),
                };
                params.zxDisplayPrice = this.state.zxDisplayPrice;
                params.hideOldfiles = this.state.hideOldfiles;
                console.log('params', params)
                delete params.proCategoryIdShow;
                showSpin();
                this.setState({submiting: true});
                if (this.id) {
                    modifyCommodity({...params, id: this.id}).then(res => {
                        hideSpin();
                        this.setState({submiting: false});
                        res.status && hashHistory.goBack();
                        message[res.status ? 'success' : 'error'](res.message);
                    });
                } else {
                    params.productList = productRelationList.map(x => ({
                        id: x.id,
                        isDefault: x.isDefault || 0,
                    }));
                    if (params.productList.every(x => !x.isDefault)) {
                        if (params.productList.length > 0) {
                            params.productList[0].isDefault = 1;
                        }
                    }
                    addCommodity(params).then(res => {
                        hideSpin();
                        this.setState({submiting: false});
                        res.status && hashHistory.goBack();
                        message[res.status ? 'success' : 'error'](res.message);
                    });
                }
            } else {
                message.error('请检查各页签中的字段都填写正确');
            }
        });
    }

    CascaderFilter = (inputValue, path) => {
        return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
    };

    setDefault(index, productId, flag) {
        let {productRelationList} = this.state;
        if (this.id > 0) {
            setDefaultProductForCommodity({
                id: this.id,
                productId: productId,
                isDefault: flag,
            }).then((res) => {
                res.status && this.getProductListForCommodity();
                openNotice(res.status ? 'success' : 'error', res.message);
            });
        } else {
            productRelationList = productRelationList.map((x) => ({
                ...x,
                isDefault: x.id === productId ? flag : 0,
            }));
            this.setState({
                productRelationList,
            });
        }
    }

    goSelectProduct() {
        const {validateFields} = this.props.form;
        validateFields(['proCategoryIdShow'], (err, values) => {
            if (!err) {
                this.setState({
                    visible: true,
                    modalParams: {
                        categoryShow: values.proCategoryIdShow,
                        proBigType: values.proCategoryIdShow[0] || '', // 商品大类
                        proMiddleType: values.proCategoryIdShow[1] || '', // 商品中类
                        proDetailType: values.proCategoryIdShow[2] || '', // 商品小类
                    },
                });
            }
        });
    }

    zxDisplayPriceOnChange(checked) {
        if (checked) {
            this.setState({zxDisplayPrice: 1})
        } else {
            this.setState({zxDisplayPrice: 0})
        }
    }

    hideOldfilesOnChange(checked) {
        this.setState({hideOldfiles: checked ? 1 : 0});
    }

    onOkHandle(selectedProducts) {
        if (this.id) {
            this.setState({visible: false});
            addProductForCommodity({
                id: this.id,
                productList: selectedProducts.map(x => ({
                    id: x.id,
                    isDefault: 0,
                })),
            }).then(res => {
                res.status && this.getProductListForCommodity();
                openNotice(res.status ? 'success' : 'error', res.message);
            });
        } else {
            this.setState({
                visible: false,
                productRelationList: selectedProducts,
                productValidateStatus: !!selectedProducts.length ? '' : 'error',
            });
        }
    }

    deleteProduct() {
        const self = this;
        const {deleteRowKeys, productRelationList} = this.state;
        if (!deleteRowKeys.length) {
            message.warn('请选择要删除的产品');
            return;
        }
        confirm({
            title: '确定要删除这些产品?',
            onOk() {
                if (self.id) {
                    showSpin();
                    delProductForCommodity({
                        id: self.id,
                        productList: deleteRowKeys.map(x => ({
                            id: x,
                            isDefault: 0,
                        })),
                    }).then(res => {
                        hideSpin();
                        self.setState({deleteRowKeys: []});
                        message[res.status ? 'success' : 'error'](res.message);
                        res.status && self.getProductListForCommodity();
                    });
                } else {
                    self.setState({
                        deleteRowKeys: [],
                        productRelationList: (productRelationList || []).filter(x => !deleteRowKeys.includes(x.id))
                    })
                }

            },
            onCancel() {
            },
        });
    }

    /*导出*/
    exportChange(item, type) {
        console.log('_searchObj', item)


        if (type == "look") {
            if (!new RegExp("(jpg|png|jpeg|bmp|gif)$").test(item.extension)) {
                message.warning('目前仅支持查看图片，你可下载查看！');
                return;
            }
            this.setState({visibleModel: true, lookFileUrl: item.file_path});
        } else {
            // window.open(`${config.server}/api/v1/dms/commonAttachUpload/getFileDown?id=${item.id}`);
            window.open(`${config.server}${item.file_path.replace("getFile", "getFileDown")}`);
        }


    };

    downloadFileExt(filePath) {
        window.open(filePath);
    }

    onSearchHandle(val) {
        this.setState({
            productParams: {
                ...this.state.productParams,
                name: val,
                p: 1,
            },
        }, () => {
            this.getProductListForCommodity();
        });
    }

    pageChange(page, pageSize) {
        this.setState({productParams: {...this.state.productParams, s: pageSize, p: page}}, () => {
            this.getProductListForCommodity();
        });
    }

    render() {
        const {
            submiting,
            detail,
            button_limits_end,
            fittingTree,
            productCategoryTree,
            productValidateStatus,
            productTotal,
            productParams,
            productRelationList,
            groupOptions,
            seriesOptions,
            visible,
            modalParams,
            deleteRowKeys,
            examiningReportData,
            informationProps,
            certificateData,
            commodityData,
            videoData,
            lookFileUrl,
            visibleModel,
            zxDisplayPrice,
            hideOldfiles
        } = this.state;
        const {getFieldDecorator, setFields} = this.props.form;
        const myUploadProps = {
            maxWidth: 360,
            maxHeight: 235,
            maxSize: 1,
            maxCount: 1,
            antdUploadProps: {
                listType: 'picture',
                showUploadList: {showRemoveIcon: true},
            },
        };
        const productModalProps = {
            visible: visible,
            width: 1400,
            params: modalParams,
            categoryTree: this.state.tree,
            onOk: this.onOkHandle,
            onCancel: () => this.setState({visible: false}),
        };
        const productTableProps = {
            rowKey: 'id',
            pagination: {
                total: productTotal,
                showTotal: total => `总共 ${total} 条`,
                current: productParams.p,
                pageSize: productParams.s,
                onShowSizeChange: (current, pageSize) => this.pageChange(1, pageSize),
                onChange: (current, pageSize) => this.pageChange(current, pageSize),
            },
            dataSource: productRelationList,
            columns: [
                {
                    title: '产品名称',
                    dataIndex: 'name',
                    width: 200,
                    render: (text, record, index) => <a href={`#/product/${record.id}`}
                                                        style={{whiteSpace: 'pre-wrap'}}>{text}</a>,
                },
                {
                    title: '产品类别',
                    dataIndex: 'proBigName',
                    render: (text, record, index) => {
                        return record.proBigName + '.' + record.proMiddleName + '.' + record.proDetailName;
                    },
                },
                {
                    title: '产品编码',
                    dataIndex: 'itemNum',
                    width: 120,
                },
                {
                    title: '产品线',
                    dataIndex: 'proLine',
                    render: (text, record, index) => {
                        if (text === '01') return '元器件';
                        if (text === '02') return '电工';
                        if (text === '03') return '电表';
                        if (text === '04') return '变频器';
                        if (text === '05') return '天e';
                        if (text === '06') return 'TG精品';
                        return '';
                    },
                },
                {
                    title: '品牌',
                    dataIndex: 'brandText',
                    // render: text => <span style={{ color: '#d61518' }}>{'¥' + text}</span>,
                },
                {
                    title: '牌价',
                    dataIndex: 'showPrice',
                    render: text => <span style={{color: '#d61518'}}>{'¥' + text}</span>,
                },
                {
                    title: '价格起始日期',
                    dataIndex: 'showPriceDate',
                    render: (val, record, index) => val && typeof val === 'number' ? new Date(val).format('yyyy-MM-dd') : val,
                },
                {
                    title: '库存',
                    dataIndex: 'inventory',
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    render: (val, record, index) => {
                        if (!!record.isDefault) {
                            return <a onClick={() => this.setDefault(index, val, 0)}>默认</a>;
                        }
                        return <a onClick={() => this.setDefault(index, val, 1)}>设为默认</a>;
                    },
                },
            ],
            rowSelection: {
                selectedRowKeys: deleteRowKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                    this.setState({deleteRowKeys: selectedRowKeys});
                },
            },
        };
        if (this.id === 0) {
            delete productTableProps.pagination;
        }


        return <div className="dms-body">
            <DmsTab options={[`${this.id ? '编辑' : '新增'}商品`]} defaultKey={0}>
                <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
                <Button type='primary' loading={submiting} onClick={this.submitHandle.bind(this)}>保存</Button>
            </DmsTab>
            <div className="tab_individual add_product">
                <Form layout="horizontal">
                    <Tabs className="my-ant-tabs">
                        <TabPane tab="基础信息" forceRender
                                 disabled={this.state.userData.roleCode == 'cpxxwh' ? true : false} key="1">
                            <div style={{padding: '12px', background: '#fff'}}>
                                <Row gutter={16}>
                                    <Col className="gutter-row" span={12}>
                                        <FormItem label="商品名称：" hasFeedback>
                                            {getFieldDecorator('name', {
                                                initialValue: detail.name || '',
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: '请输入物料编码',
                                                    },
                                                ],
                                            })(<Input/>)}
                                        </FormItem>
                                    </Col>
                                    <Col className="gutter-row" span={12}>
                                        <div style={{display: 'none'}}>
                                            <FormItem label="商品分类Id" hasFeedback>
                                                {getFieldDecorator('proCategoryId', {
                                                    initialValue: detail.proCategoryId || '',
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: '请选择产品分类',
                                                        },
                                                    ],
                                                })(<Input placeholder="请选择产品分类"/>)}
                                            </FormItem>
                                        </div>
                                        <FormItem label="商品分类：" hasFeedback>
                                            {getFieldDecorator('proCategoryIdShow', {
                                                initialValue: detail.proCategoryIdShow || undefined,
                                                getValueFromEvent: (value, selectedOptions) => {
                                                    let lastOption = selectedOptions.pop();
                                                    setFields({
                                                        proCategoryId: {
                                                            value: lastOption ? lastOption.categoryId || '' : '',
                                                            errors: undefined,
                                                        },
                                                    });
                                                    return value;
                                                },
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: '请选择商品分类',
                                                    },
                                                ],
                                            })(
                                                <Cascader
                                                    options={productCategoryTree}
                                                    placeholder="请选择产品分类"
                                                    showSearch={{filter: this.CascaderFilter}}
                                                />)}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col className="gutter-row" span={12}>
                                        <FormItem label="商品分组：" hasFeedback>
                                            {getFieldDecorator('groupCode', {
                                                initialValue: detail.groupCode || undefined,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: '请选择商品分组',
                                                    },
                                                ],
                                            })(<Select>
                                                {groupOptions.map(x => <Option key={x.value}>{x.text}</Option>)}
                                            </Select>)}
                                        </FormItem>
                                    </Col>
                                    <Col className="gutter-row" span={12}>
                                        <FormItem label="商品系列：" hasFeedback>
                                            {getFieldDecorator('seriesCode', {
                                                initialValue: detail.seriesCode || '',
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: '请选择商品系列',
                                                    },
                                                ],
                                            })(<Select>
                                                {seriesOptions.map(x => <Option key={x.value}>{x.text}</Option>)}
                                            </Select>)}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col className="gutter-row" span={12}>
                                        <div style={{display: 'none'}}>
                                            <FormItem label="商品配件类别" hasFeedback>
                                                {getFieldDecorator('partsTypeJson', {
                                                    initialValue: detail.partsTypeJson || '',
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: '请选择商品配件类别',
                                                        },
                                                    ],
                                                })(<Input placeholder="请选择商品配件类别"/>)}
                                            </FormItem>
                                        </div>
                                        <FormItem label="商品配件分类：" hasFeedback>
                                            {getFieldDecorator('partCategoryIds', {
                                                initialValue: detail.partCategoryIds || undefined,
                                                getValueFromEvent: (value, label, extra) => {
                                                    let list = extra.allCheckedNodes.map(x => x.node.props.codePath);
                                                    setFields({
                                                        partsTypeJson: {
                                                            value: JSON.stringify(list),
                                                            errors: undefined,
                                                        },
                                                    });
                                                    return value;
                                                },
                                                rules: [
                                                    {
                                                        required: false,
                                                        message: '请选择商品配件类别',
                                                    },
                                                ],
                                            })(
                                                <TreeSelect
                                                    style={{width: '100%'}}
                                                    treeCheckable={true}
                                                    dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                                                    treeData={fittingTree}
                                                    placeholder="请选择商品配件分类"
                                                    treeDefaultExpandAll={false}
                                                    filterTreeNode={(inputValue, treeNode) => treeNode.props.title.toLowerCase().indexOf(inputValue.toLowerCase()) >= -1}
                                                />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col className="gutter-row" span={12}>
                                        <FormItem label="是否屏蔽价格" hasFeedback>
                                            {getFieldDecorator('zxDisplayPrice', {
                                                initialValue: zxDisplayPrice || 0,
                                                rules: [
                                                    {
                                                        required: false,
                                                        message: '请选择是否屏蔽价格',
                                                    },
                                                ],
                                            })(<Switch checked={zxDisplayPrice || 0}
                                                       onChange={this.zxDisplayPriceOnChange}/>)}
                                        </FormItem>
                                    </Col>
                                    <Col className="gutter-row" span={12}>
                                        <FormItem label="是否屏蔽老文件" hasFeedback>
                                            {getFieldDecorator('hideOldfiles', {
                                                initialValue: hideOldfiles || 0,
                                                rules: [
                                                    {
                                                        required: false,
                                                        message: '请选择是否屏蔽老文件',
                                                    },
                                                ],
                                            })(<Switch checked={!!hideOldfiles}
                                                       checkedChildren="是"
                                                       unCheckedChildren="否"
                                                       onChange={this.hideOldfilesOnChange}/>)}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <FormItem label="商品描述：" hasFeedback>
                                    {getFieldDecorator('description', {
                                        initialValue: detail.description || undefined,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入广告描述',
                                                min: 1,
                                                max: 128,
                                            },
                                        ],
                                    })(<TextArea rows={4} placeholder="请输入广告描述"/>)}
                                </FormItem>
                                <DmsTab options={['关联产品']} defaultKey={0}>
                                    <Button onClick={() => this.goSelectProduct()}>添加</Button>
                                    &emsp;
                                    <Button onClick={() => this.deleteProduct()}>删除</Button>
                                </DmsTab>
                                <Form.Item
                                    label={null}
                                    validateStatus={productValidateStatus}
                                    help={productValidateStatus === 'error' ? '请添加关联产品' : ''}
                                >
                                    <Search
                                        placeholder="输入物料名称/编号"
                                        style={{width: 200}}
                                        value={productParams.name}
                                        onChange={e => this.setState({
                                            productParams: {
                                                ...this.state.productParams,
                                                name: e.target.value,
                                            },
                                        })}
                                        onSearch={value => this.onSearchHandle(value)}
                                    />
                                    <div className="dms-table-box">
                                        <Table {...productTableProps} />
                                    </div>
                                </Form.Item>
                            </div>
                        </TabPane>
                        <TabPane tab="产品概述" forceRender key="2"
                                 disabled={this.state.userData.roleCode == 'cpxxwh' ? true : false}>
                            <div style={{padding: '16px 12px', background: '#fff'}}>
                                <FormItem
                                    className="mt20"
                                    label="商品缩略图"
                                    extra={<small>建议图片大小：360x235px；图片格式jpg、png、jpeg；图片大小小于1M</small>}
                                >
                                    {getFieldDecorator('picPreviewIds', {
                                        initialValue: detail.picPreviewIds || undefined,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请上传商品缩略图',
                                            },
                                        ],
                                    })(
                                        <MyUpload {...myUploadProps}>
                                            <Button icon="upload">点击上传</Button>
                                        </MyUpload>,
                                    )}
                                </FormItem>
                                <FormItem
                                    label="产品主图"
                                    extra={
                                        <small>最多可上传5张图片，建议图片大小：750x550px；图片格式jpg、png、jpeg；图片大小小于1M</small>}
                                >
                                    {getFieldDecorator('picMainIds', {
                                        initialValue: detail.picMainIds || undefined,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请上传商品主图',
                                            },
                                        ],
                                    })(
                                        <MyUpload {...{...myUploadProps, maxCount: 5, maxWidth: 750, maxHeight: 550}}>
                                            <Button icon="upload">点击上传</Button>
                                        </MyUpload>,
                                    )}
                                </FormItem>
                                <div style={{padding: '0px 30px 0px 0px', background: '#fff'}}>
                                    {this.id && detail.commodityList ?
                                        <div style={{margin: '0 0 40px 0'}}>
                                            <label label> 上传产品附件：</label>
                                            <Upload {...commodityData} >
                                                <Button>
                                                    <Icon type="upload"/> 上传附件
                                                </Button>
                                            </Upload>
                                        </div>
                                        : ''}

                                    {this.id && detail.commodityList ?

                                        <div>

                                            {
                                                detail.commodityList.map((item, index) => {

                                                    return (
                                                        <div>

                                                            <div className="db vh displayTree" key={item.id}>
                                                                <img className="detail_img"
                                                                     src={detail.file_path ? `${config.server}${detail.file_path}` : ''}/>
                                                                <div>{item.fileName}</div>
                                                                <Button
                                                                    onClick={this.exportChange.bind(this, item, 'look')}>查看 </Button>

                                                                <Button type='primary'
                                                                        onClick={this.exportChange.bind(this, item, 'dow')}>下载</Button>
                                                                <Icon style={{cursor: 'pointer'}}
                                                                      onClick={this.delCommodity.bind(this, item, 'dow')}
                                                                      type="delete"/>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        :
                                        <div>
                                            <label label> 上传产品附件：</label>
                                            <Upload {...commodityData} >
                                                <Button>
                                                    <Icon type="upload"/> 上传附件
                                                </Button>
                                            </Upload>
                                        </div>
                                    }
                                    <div>
                                        {detail.dmsCommonAttachFileExternalList != null && <ul>
                                            {detail.dmsCommonAttachFileExternalList.map((itm, index) => {
                                                if (itm.fileType == 'sample' || itm.fileType == 'InstructionManual' || itm.fileType == 'specification') {
                                                    return (<li style={{'marginTop': '10px'}}>
                                                        <div>{itm.fileName} &nbsp;<Button
                                                            type='primary'
                                                            onClick={this.downloadFileExt.bind(this, itm.filePath)}>下载</Button>
                                                        </div>
                                                    </li>)
                                                }
                                            })}
                                        </ul>
                                        }
                                    </div>
                                </div>

                                {/*<div style={{padding: '0px 30px 0px 0px', background: '#fff'}}>*/}
                                {/*    {this.id && detail.videoList ?*/}
                                {/*        <div style={{margin: '0 0 40px 0'}}>*/}
                                {/*            <label label> 上传产品视频：</label>*/}
                                {/*            <Upload {...videoData} >*/}
                                {/*                <Button>*/}
                                {/*                    <Icon type="upload"/> 上传视频*/}
                                {/*                </Button>*/}
                                {/*            </Upload>*/}
                                {/*        </div>*/}
                                {/*        : ''}*/}

                                {/*    {this.id && detail.videoList ?*/}

                                {/*        <div>*/}

                                {/*            {*/}
                                {/*                detail.videoList.map((item, index) => {*/}

                                {/*                    return (*/}
                                {/*                        <div>*/}

                                {/*                            <div className="db vh displayTree" key={item.id}>*/}
                                {/*                                <img className="detail_img"*/}
                                {/*                                     src={detail.file_path ? `${config.server}${detail.file_path}` : ''}/>*/}
                                {/*                                <div>{item.fileName}</div>*/}
                                {/*                                <Button*/}
                                {/*                                    onClick={this.exportChange.bind(this, item, 'look')}>查看 </Button>*/}

                                {/*                                <Button type='primary'*/}
                                {/*                                        onClick={this.exportChange.bind(this, item, 'dow')}>下载</Button>*/}
                                {/*                                <Icon style={{cursor: 'pointer'}}*/}
                                {/*                                      onClick={this.delVideo.bind(this, item, 'dow')}*/}
                                {/*                                      type="delete"/>*/}
                                {/*                            </div>*/}
                                {/*                        </div>*/}
                                {/*                    )*/}
                                {/*                })*/}
                                {/*            }*/}
                                {/*        </div>*/}
                                {/*        :*/}
                                {/*        <div>*/}
                                {/*            <label label> 上传产品视频：</label>*/}
                                {/*            <Upload {...videoData} >*/}
                                {/*                <Button>*/}
                                {/*                    <Icon type="upload"/> 上传视频*/}
                                {/*                </Button>*/}
                                {/*            </Upload>*/}
                                {/*        </div>*/}
                                {/*    }*/}
                                {/*</div>*/}
                                <FormItem label="视频链接：">
                                    {getFieldDecorator('videoIds', {
                                        initialValue: detail.videoIds || '',
                                        rules: [
                                            {
                                                required: false,
                                                message: '请输入视频链接',
                                            },
                                        ],
                                    })(<Input/>)}
                                </FormItem>
                                <FormItem label="图文详情">
                                    {getFieldDecorator('imageTextDetail', {
                                        initialValue: detail.imageTextDetail || '',
                                        valuePropName: 'htmlContent',
                                        validateTrigger: 'onBlur',
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入图文详情',
                                            },
                                        ],
                                    })(
                                        <RichEditor/>,
                                    )}
                                </FormItem>
                            </div>
                        </TabPane>
                        <TabPane tab="技术参数" forceRender key="3">
                            <div style={{padding: '12px', background: '#fff'}}>
                                <FormItem label={null} colon={false}>
                                    {getFieldDecorator('commodityParameters', {
                                        initialValue: detail.commodityParameters || '',
                                        valuePropName: 'htmlContent',
                                        validateTrigger: 'onBlur',
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入商品参数',
                                            },
                                        ],
                                    })(
                                        <RichEditor/>,
                                    )}
                                </FormItem>
                            </div>
                        </TabPane>
                        <TabPane tab="安装尺寸" forceRender key="4"
                                 disabled={this.state.userData.roleCode == 'cpxxwh' ? true : false}>
                            <div style={{padding: '12px', background: '#fff'}}>
                                <FormItem label={null} colon={false}>
                                    {getFieldDecorator('mountingDimension', {
                                        initialValue: detail.mountingDimension || '',
                                        valuePropName: 'htmlContent',
                                        validateTrigger: 'onBlur',
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入商品参数',
                                            },
                                        ],
                                    })(
                                        <RichEditor/>,
                                    )}
                                </FormItem>
                            </div>
                        </TabPane>
                        <TabPane tab="检测报告" forceRender key="5"
                                 disabled={this.state.userData.roleCode == 'cpxxwh' ? true : false}>
                            <div style={{padding: '30px 30px 400px 30px', background: '#fff'}}>
                                {this.id && detail.examiningReportList ?
                                    <div style={{margin: '0 0 40px 0'}}>
                                        <label label> 上传检测报告：</label>
                                        <Upload {...examiningReportData} >
                                            <Button>
                                                <Icon type="upload"/> 上传附件
                                            </Button>
                                        </Upload>
                                    </div>
                                    : ''}

                                {this.id && detail.examiningReportList ?

                                    <div>

                                        {
                                            detail.examiningReportList.map((item, index) => {

                                                return (
                                                    <div>


                                                        <div className="db vh displayTree" key={item.id}>
                                                            <img className="detail_img"
                                                                 src={detail.file_path ? `${config.server}${detail.file_path}` : ''}/>
                                                            <div>{item.fileName}</div>
                                                            <Button
                                                                onClick={this.exportChange.bind(this, item, 'look')}>查看 </Button>

                                                            <Button type='primary'
                                                                    onClick={this.exportChange.bind(this, item, 'dow')}>下载</Button>
                                                            <Icon style={{cursor: 'pointer'}}
                                                                  onClick={this.delFileReport.bind(this, item, 'dow')}
                                                                  type="delete"/>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    :
                                    <div>
                                        <label label> 上传检测报告：</label>
                                        <Upload {...examiningReportData} >
                                            <Button>
                                                <Icon type="upload"/> 上传附件
                                            </Button>
                                        </Upload>
                                    </div>
                                }
                                <div>
                                    {detail.dmsCommonAttachFileExternalList != null && <ul>
                                        {detail.dmsCommonAttachFileExternalList.map((itm, index) => {
                                            if (itm.fileType == 'InspectionReport') {
                                                return (<li style={{'marginTop': '10px'}}>
                                                    <div>{itm.fileName} &nbsp;<Button
                                                        type='primary'
                                                        onClick={this.downloadFileExt.bind(this, itm.filePath)}>下载</Button>
                                                    </div>
                                                </li>)
                                            }
                                        })}
                                    </ul>
                                    }
                                </div>
                            </div>

                        </TabPane>
                        <TabPane tab="认证证书" forceRender key="6"
                                 disabled={this.state.userData.roleCode == 'cpxxwh' ? true : false}>
                            <div style={{padding: '30px 30px 400px 30px', background: '#fff'}}>
                                {this.id && detail.certificateList ?
                                    <div style={{margin: '0 0 40px 0'}}>
                                        <label label> 上传认证证书：</label>
                                        <Upload {...certificateData} >
                                            <Button>
                                                <Icon type="upload"/> 上传附件
                                            </Button>
                                        </Upload>
                                    </div>
                                    : ''}

                                {this.id && detail.certificateList ?

                                    <div>

                                        {
                                            detail.certificateList.map((item, index) => {

                                                return (
                                                    <div>


                                                        <div className="db vh displayTree" key={item.id}>
                                                            <img className="detail_img"
                                                                 src={detail.file_path ? `${config.server}${detail.file_path}` : ''}/>
                                                            <div>{item.fileName}</div>
                                                            <Button
                                                                onClick={this.exportChange.bind(this, item, 'look')}>查看 </Button>

                                                            <Button type='primary'
                                                                    onClick={this.exportChange.bind(this, item, 'dow')}>下载</Button>
                                                            <Icon style={{cursor: 'pointer'}}
                                                                  onClick={this.delFileCertificateList.bind(this, item, 'dow')}
                                                                  type="delete"/>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    :
                                    <div>
                                        <label label> 上传认证证书：</label>
                                        <Upload {...certificateData} >
                                            <Button>
                                                <Icon type="upload"/> 上传附件
                                            </Button>
                                        </Upload>
                                    </div>
                                }
                                <div>
                                    {detail.dmsCommonAttachFileExternalList != null && <ul>
                                        {detail.dmsCommonAttachFileExternalList.map((itm, index) => {
                                            if (itm.fileType == 'certificate') {
                                                return (<li style={{'marginTop': '10px'}}>
                                                    <div>{itm.fileName} &nbsp;<Button
                                                        type='primary'
                                                        onClick={this.downloadFileExt.bind(this, itm.filePath)}>下载</Button>
                                                    </div>
                                                </li>)
                                            }
                                        })}
                                    </ul>
                                    }
                                </div>
                            </div>

                        </TabPane>
                    </Tabs>
                </Form>
            </div>

            <ProductModal {...productModalProps} />
            <Modal
                visible={this.state.visibleModel}
                title="查看图片"
                onOk={this.handleCancel}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={"50%"}
                style={{top: "30%"}}
            >
                <div>
                    <div style={{padding: '12px', background: '#fff'}}>
                        <img style={{width: '100%'}} src={lookFileUrl ? `${config.server}${lookFileUrl}` : ''}/>
                    </div>
                </div>
            </Modal>
        </div>
    }
}

export default withRouter(Form.create()(MerchandiseAdd));



// WEBPACK FOOTER //
// ./src/routes/merchandise/add.js